import React, { useState, useEffect, useContext } from "react";
import tick from "../Assets/Tick.svg";
import box from "../Assets/Box.svg";
import { useNavigate } from "react-router-dom";

function ToggleTick({ onToggle }) {
  const [showTick, setShowTick] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    onToggle(showTick);
  }, [showTick, onToggle]);

  const toggleTick = () => {
    setShowTick(!showTick);
  };
  function navigateToEmailPassword() {
    navigate("/EmailPassword");
  }
  return (
    <div className="remember-forgot">
      <img
        src={showTick ? tick : box}
        alt=""
        className="tick-svg"
        onClick={toggleTick}
      />
      <span className="remember-me">Remember me</span>
      <button onClick={navigateToEmailPassword} className="forgot-password">
        Forgot your password?
      </button>{" "}
    </div>
  );
}

export default ToggleTick;
